import { ProtobufHttpClient } from "@ftdr/http-utils";
import { Payment3_paymentmethod_coordinatorJSClient } from "@ftdr/payment3_paymentmethod_coordinator-js-client";
import { Mixin } from "ts-mixer";
import { DebugIdentifiers } from "../../../utils";

export class PaymentMethodCoordinatorJSClient extends Mixin(
  DebugIdentifiers,
  Payment3_paymentmethod_coordinatorJSClient
) {
  constructor(baseUrl: string, httpClient: ProtobufHttpClient) {
    super(baseUrl, httpClient);
    this.httpClient = httpClient;
  }
}
